import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Contest } from 'src/app/models/contest';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-contest-modal',
  templateUrl: './contest-modal.component.html',
  styleUrls: ['./contest-modal.component.scss'],
})
export class ContestModalComponent implements OnInit {
  @Input() contests: Contest[] = [];
  bannerData: any = { banners: [] };
  @Input() modifiedBill: boolean = false;

  digitalContests: any[] = [];

  documentNumber: string = '';
  documentType: string = '';

  constructor(
    private modalCtrl: ModalController,
    private configService: ConfigService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadBanners();

    this.digitalContests = (this.contests || []).filter(
      (contest: any) => contest?.tickets_reward_settings?.type === 'digital'
    );

    this.documentNumber = localStorage.getItem('document_number') || '';
    this.documentType = localStorage.getItem('document_type') || '';

    console.log('concursos: ', this.contests)
    console.log('factura modificada?: ', this.modifiedBill)
    console.log('concursos digitales: ', this.digitalContests)

  }

  loadBanners() {
    this.configService.getUpdateDataFields().subscribe({
      next: (data: any) => {
        this.bannerData = { banners: data?.banners || [] };
      },
      error: (err) => {
        console.error('Error loading update-data-fields', err);
      },
    });
  }

  close() {
    this.modalCtrl.dismiss(false);
  }

  async submit() {
    await this.modalCtrl.dismiss(true);
  }

  goUpdateData() {
    this.router.navigate(['/update-data']);
    this.modalCtrl.dismiss();
  }

  getDigitalContestNames(): string {
    return this.digitalContests
      .map(contest => contest.name)
      .join(', ');
  }


}
